console.log('✅ main-search-page-filter-shared-state.js loaded successfully!');

// src/store.js
export const searchPageComponentSharedState = {
  // your shared state
  pageSpecificListOfSpecOptionsSelectedFilters: [], // Array of { SpecID, OptionID, … }

  layoutType: '',
  currentProductID: '',

  searchRequestModel: {
    SearchString: '',
    MaxPrice: '',
    MinPrice: '',
    MinMOQ: '',
    MaxMOQ: '',
    ListOfSpecOptionsIDs: '',
    ListOfSpecIDs: '',
    ListOfDepartmentIDs: '',
    ListOfCategoryIDs: '',
    ListOfProductIDs: '',
    CanBuyNow: '',
    CanRentOrLease: '',
    ListOfUnitOfMeasureIDs: '',
    GroupSearchResult: '',
    IsProducer: '',
    ListOfSupplierTypeID: '',
    IsWholeseller: '',
    ListOfSellerLevel: '',
    OfferCustomLogo: '',
    OfferCustomPackaging: '',
    OfferProductRedesign: '',
    ListOfShippedFromCountryID: '',
    ListOfCountryOfOriginID: '',
    ListOfCountryOfSellerID: '',
    IsTrending: '',
    IsFeatured: '',
    ListOfBuyingCompanyID: '',
    LanguageCode: '',
    OrderByDirection: '',
    PageNumber: '',
    NumberOfResultsToReturnPerPage: '',
    SelectedCountryID: '',
    SelectedStateID: '',
    SelectedCityID: '',
    SearchLoggedInUserID: '',
    SearchBuyingEntityID: '',
    SearchBuyingEntityType: '',
  },

  // internal list of subscribers
  _listeners: new Set(),

  // searchRequestModel actions

  setSearchRequest(newReq, emit = true) {
    this.searchRequestModel = newReq;

    if (emit) this._emitChange();
  },

  getSearchRequest() {
    return this.searchRequestModel;
  },

  //// granular update of a single field
  //updateSearchField(key, value) {
  //    if (key in this.searchRequestModel) {
  //        this.searchRequestModel[key] = value;
  //        this._emitChange();
  //    } else {
  //        console.warn(`Unknown search‑field: ${key}`);
  //    }
  //},

  /**
   * Update a single field.  By default emits immediately.
   * If `emit: false`, you can batch multiple calls.
   */
  updateSearchField(key, value, emit = true) {
    if (!(key in this.searchRequestModel)) {
      console.warn(`Unknown searchRequestModel field: ${key}`);
      return;
    }
    this.searchRequestModel[key] = value;
    if (emit) this._emitChange();
  },

  updateSearchMultiple(updates, emit = true) {
    Object.assign(this.searchRequestModel, updates);
    if (emit) this._emitChange();
  },

  // delete a field (falls back to "")
  deleteSearchField(key, emit = true) {
    if (key in this.searchRequestModel) {
      this.searchRequestModel[key] = '';
      if (emit) this._emitChange();
    }
  },

  // clear everything back to its initial default
  clearSearchRequest(emit = true) {
    for (const k of Object.keys(this.searchRequestModel)) {
      this.searchRequestModel[k] = '';
    }
    if (emit) this._emitChange();
  },

  //  pageSpecificListOfSpecOptionsSelectedFilters actions
  // read
  getFilters() {
    return this.filters;
  },

  // write + notify
  setFilters(newFilters) {
    this.filters = newFilters;
    this._emitChange();
  },

  /**
   * Manually trigger a change notification.
   */
  notify() {
    this._emitChange();
  },

  // subscribe/unsubscribe
  subscribe(fn) {
    this._listeners.add(fn);
    return () => this._listeners.delete(fn);
  },
  _emitChange() {
    alert('searchPageComponentSharedState._emitChange() called');
    for (const fn of this._listeners) fn(this);
  },
};

//example usage:

//// 1) Batch several silent updates:
//searchPageComponentSharedState.updateSearchField(
//    'ListOfShippedFromCountryID',
//    shippedFromIDs.join(','),
//    { emit: false }
//);
//searchPageComponentSharedState.updateSearchField(
//    'ListOfCountryOfOriginID',
//    originIDs.join(','),
//    { emit: false }
//);
//searchPageComponentSharedState.updateSearchField(
//    'ListOfCountryOfSellerID',
//    sellerCountryIDs.join(','),
//    { emit: false }
//);

//// 2) call your API now, using the up‑to‑date model:
////    e.g. await fetchDataSearchPageWithFilters(lang);

//// 3) once the API is done, trigger your subscribers exactly once:
//searchPageComponentSharedState.notify();

//searchPageComponentSharedState.subscribe(async (store) => {
//    // this only runs when you call `notify()`, or when you do a non-silent update
//    await populateSearchPageWithFilters(lang, layoutType);
//});
